import { makeStyles } from '@material-ui/core';
import colors from 'styles/colors';
import themeStyle from 'styles/theme';

const signInStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(12), // 96px
    maxWidth: theme.spacing(55), // 440px
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing(4)
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1.5)
  },
  title: {
    fontSize: 30,
    fontWeight: 600,
    width: 'fit-content'
  },
  subtitle: {
    ...themeStyle.typography.mdRegular,
    color: colors.gray[600],
    width: 'fit-content'
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  tab: {
    flex: 1
  },
  // Form classes
  actionsWrapper: {
    margin: `${theme.spacing(1)}px 0`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  checkboxIcon: { padding: `0 ${theme.spacing(1)}px` },
  checkboxLabel: {
    ...themeStyle.typography.smMedium,
    color: colors.gray[700]
  },
  forgotPassword: {
    ...themeStyle.typography.smSemibold,
    color: colors.brand[700]
  }
}));

export default signInStyles;
